// @flow
import React from 'react';
import type { Badge as Props } from './badge.type';

const Badge = (props: Props) => {
  const modifiers =
    typeof props.modifiers === 'string' ? [props.modifiers] : props.modifiers;

  // eslint-disable-next-line prefer-template
  const classes = `c-badge ${(modifiers || [])
    .map(modifier => `c-badge--${modifier}`)
    .join(' ')}`;

  return (
    <span className={classes}>
      <span className="u-hidden">(</span>
      {props.label}
      <span className="u-hidden">)</span>
    </span>
  );
};

Badge.defaultProps = {
  modifiers: [],
};

export default Badge;
